import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-1b6d87fa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  key: 0,
  class: "title"
};
var _hoisted_3 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "banner-container",
    style: _normalizeStyle("height:".concat(_ctx.height, "px;background-image:url(").concat(_ctx.image, ")"))
  }, [_createElementVNode("div", _hoisted_1, [_ctx.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])])], 4);
}